import { Component } from '@angular/core';
import { LayoutModule, WebAppCommonModule } from '@allbesmart/web-app-common';
import { WebAppKeycloakAuthModule } from '@allbesmart/web-app-keycloak-auth';

@Component({
    selector: 'oaibox-kc-unauthorized-page',
    templateUrl: './kc-unauthorized-page.component.html',
    styleUrls: ['./kc-unauthorized-page.component.css'],
    imports: [LayoutModule, WebAppKeycloakAuthModule, WebAppCommonModule]
})
export class KcUnauthorizedPageComponent {

}
